import { useState } from 'react';

function defaultCheckEquals<T>(value: T, current: T): boolean {
  return value === current;
}

// Implementation from https://usehooks.com/
export function usePrevious<T>(
  value: T,
  checkEquals: (value: T, current: T) => boolean = defaultCheckEquals,
): T | null {
  const [current, setCurrent] = useState<T>(value);
  const [previous, setPrevious] = useState<T | null>(null);

  if (!checkEquals(value, current)) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}
